<template lang="pug">
  button.action-button(@click="click($event)", :disabled="disabled || loading", :class="{ disabled, loading }") {{ loading ? "" : title }}
</template>

<script>
export default {
  name: 'ActionButton',
  props: {
    title: {
      type: String,
      required: true
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false
    },
    loading: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  methods: {
    click (event) {
      if (this.disabled || this.loading) {
        return
      }

      this.$emit("click", event)
    }
  }
}
</script>

<style lang="sass">
.action-button
  color: white
  height: 32px
  font-size: 18px
  width: 180px
  border-radius: 99999px
  outline: none
  background-color: #FF8800
  border: none
  cursor: pointer

  &.disabled
    background-color: #FFFFFF

  &.loading

    &:before
      content: url("../assets/Loading.svg")
      display: inline-block
      position: relative
      top: 2px
      animation: spin 0.8s linear infinite
      height: 21px
      width: 21px

      @keyframes spin
        from
          transform: rotate(0deg)
        to
          transform: rotate(360deg)
</style>
